import { defineComponent, h } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { t } from '@/ui/i18n/i18n';

export const Checkbox = defineComponent<ItemProps>({
  name: 'Checkbox',
  props: ['item'],
  setup(props) {
    return function render() {
      return h('div', [props.item.response === true ? t('inspection-report.true') : t('inspection-report.false')]);
    };
  },
});
